import { render, staticRenderFns } from "./DataEntryForCustomers.vue?vue&type=template&id=5c62c118&scoped=true&"
import script from "./DataEntryForCustomers.vue?vue&type=script&lang=js&"
export * from "./DataEntryForCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62c118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c62c118')) {
      api.createRecord('5c62c118', component.options)
    } else {
      api.reload('5c62c118', component.options)
    }
    module.hot.accept("./DataEntryForCustomers.vue?vue&type=template&id=5c62c118&scoped=true&", function () {
      api.rerender('5c62c118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/CustomersPage/DataEntryForCustomers.vue"
export default component.exports